
import React, { useEffect, useState } from 'react'
import crmservices from '../../wsclient';
import { useTranslation } from 'react-i18next';
import { custom_page } from '../../custom.config';
import ConfirmComponent from '../../components/Confirm';
import { replaceParamTranslation } from '../../utils/util';
import { saveDataIntoAsyncStore } from '../../utils/common';
import LoadingComponent from '../../components/Loading';
import { useLocation, useNavigate } from 'react-router-dom';
import { config_path } from '../../router/config.path';
import AlertComponent from '../../components/Alert';
import CommunitiesView2 from './CommunitiesView2';
import { cache } from '../../utils/cache';
import CommunityMembersView from './CommunityMembersView';
import AddMemberController from '../my-plans/AddMemberController';
import CommunityMemberView from './CommunityMemberView';
import NewCommunityView from './NewCommunityView';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';

const CommunitiesPage = custom_page.communities && custom_page.communities.view ? require('../../custom_src/pages/my-plans/CommunitiesView').default : CommunitiesView2;
const AddMemberPage = custom_page.communities && custom_page.communities.people && custom_page.communities.people.controller ? require('../../custom_src/pages/my-plans/AddEditPeopleController').default : AddMemberController;

export default function CommunitiesController2(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const fromMenuProfile = location && location.state && location.state.from === 'menu_profile' ? true : false;
    const selectedCommunity = location && location.state && location.state.community ? location.state.community : null;
    const from = location && location.state && location.state.from ? location.state.from : props.from;
    const [showProcessing, setShowProcessing] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [showCommunitiesLoading, setShowCommunitiesLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [message, setMessage] = useState();
    const [members, setMembers] = useState([]);
    const [active, setActive] = useState(selectedCommunity? 'members' : 'communities');
    const [people, setPeople] = useState(null)
    const [confirm, setConfirm] = useState(null);
    const [communitySelected, setCommunitySelected] = useState(selectedCommunity);
    const [showConfirmWithMessage, setShowConfirmWithMessage] = useState({
        show: false,
        message: null,
        type: null
    });
    const [groups, setGroups] = useState([]);
    const [joinedGroups, setJoinedGroups] = useState([]);
    const [memberSelected, setMemberSelected] = useState(null);
    const [relations, setRelations] = useState([]);
    const [showCommunityType, setShowCommunityType] = useState(false);
    const [allowances, setAllowances] = useState(null);
    const isFullAccess = false;
    const [showNewGroup, setShowNewGroup] = useState(false);
    const [defaultRelation, setDefaultRelation] = useState(null);
    const [defaultValues, setDefaulValues] = useState({
            invitation_method: { label: "EMAIL", value: "EMAIL" },
            access_level: {
                label: isFullAccess ? t('access_level_full') : t('access_level_restricted'),
                value: isFullAccess ? "FULL_ACCESS" : "RESTRICTED_ACCESS"
            },
            restricted_access: {
                contact_management: false,
                service_requests_management: false,
                orders_management: false,
            }
        })

    useEffect(() => {
        onLoadMyGroups();
        onLoadJoinedCommunities();
    }, [])

    useEffect(() => {
        onLoadMembers(communitySelected);
    }, [location.state && location.state.item])

    const onLoadMyGroups = async () => {
        setShowCommunitiesLoading(true);
        try {
            const result = await crmservices.communitity.getContactGroups();
            if (result.code === 'OK') {
                const myGroups = result.data.groups.map((item) => ({
                    group: item,
                    isOwner: true,
                    ownerId: cache.getContact().id
                }));
                setGroups(prev => [...prev, ...myGroups]);
            }
        } catch (error) {
            console.log("onLoadCommunities error:", error);
        }
    };
    
    const onLoadJoinedCommunities = async () => {
        try {
            const result = await crmservices.communitity.getListJoinedCommunities();
            if (result.code === 'OK' && result.data.content) {
                const joinedGroups = result.data.content.map((item) => ({
                    group: item.group,
                    isOwner: false,
                    ownerId: item.community_owner.id,
                    ownerName : item.community_owner.first_name + (item.community_owner.last_name ? " " + item.community_owner.last_name : ""),
                }));
                let joinedCommunities = await dataUtil.getJoinedCommunities(result.data.content);
                if (joinedCommunities && joinedCommunities.length > 0) {
                    cache.setHasCommunities(true);
                }
                let myJoinedCommunities = await onLoadMyJoinedCommunities(joinedCommunities);
                setJoinedGroups(myJoinedCommunities);
                setGroups(prev => [...prev, ...joinedGroups]);
            }
        } catch (error) {
            console.log("onLoadJoinedCommunities error:", error);
        }
    };

    const onLoadMyJoinedCommunities = async (joinedCommunities) => {
        let _joinedCommunities = [];
        if (joinedCommunities && joinedCommunities.length > 0) {
            joinedCommunities.forEach(item => {
                let ownerName = '';
                if (item.community_owner && item.community_owner.first_name) ownerName = item.community_owner.first_name;
                if (item.community_owner && item.community_owner.last_name) ownerName += ' ' + item.community_owner.last_name;
                item.name = ownerName ? ownerName : item.name;
                
                let accessLevel = "";
                let isAccess = true;
                let isAdmin = item.is_admin;
                if (isAdmin) {
                    accessLevel = t('admin_access');
                } else {
                    if (item.permissions && item.permissions.length > 0) {
                        let convertPermission = [];
                        item.permissions.forEach(element => {
                            if (element.includes("CONTACT_MANAGEMENT")) {
                                convertPermission.push(t('contact_management'));
                            }
                            if (element.includes("SERVICE_REQUESTS_MANAGEMENT")) {
                                convertPermission.push(t('service_requests_management'));
                            }
                            if (element.includes("ORDERS_MANAGEMENT")) {
                                convertPermission.push(t('orders_management'));
                            }
                        });
                        accessLevel = convertPermission.join(', ');
                    } else {
                        accessLevel = t('no_access');
                        isAccess = false
                    }
                }
                item.access_level = accessLevel;
                item.is_access = isAccess;
                if(item.is_access) {
                    _joinedCommunities.push(item)
                }
            });
        }
        setShowCommunitiesLoading(false);
        return _joinedCommunities;
    }


    const onLoadMembers = async (item) => {
        setShowLoading(true);
        try {
            const result = await crmservices.communitity.getCommunityMembers({
                owner_id: item.ownerId,
                group: item.group
            });
            if (result.code === 'OK' && result.data.content) {
                const owner = result.data.content.find(member => member.contact.id === item.ownerId);
                const otherMembers = result.data.content.filter(member => member.contact.id !== item.ownerId);
                const sortedMembers = [owner, ...otherMembers];
                setMembers(sortedMembers);
            }
        } catch (error) {
            console.log("onLoadJoinedCommunities error:", error);
        }
        setShowLoading(false);
    };

    const onLoadMember = async (item) => {
        try {
            const result = await crmservices.communitity.getCommunityMember(communitySelected.ownerId, item.relationship_id);
            if (result.code === 'OK' && result.data) {
                setAllowances(result.data);
            }
        } catch (error) {
            console.log("onLoadMember error:", error);
        }
    };

    const onSeeMembers = async (item) => {
        onLoadMembers(item);
        setActive('members');
        setCommunitySelected(item);
    }

    const onSeeMember = async (item) => {
        setShowLoading(true);
        await onLoadMember(item);
        setActive('member');
        setMemberSelected(item);
        setShowLoading(false);
    }


    const onCreateNewGroup = async () => {
        setShowNewGroup(true);
        await onLoadRelations();
    }

    const onLoadRelations = async () => {
        setShowLoading(true);
        try {
            var result = await crmservices.communitity.getCommunityRelations();
            if (result.code === 'OK') {
                let otherRelation = {
                    id: null,
                    name: t('none')
                }
                let otherRelations = [otherRelation, ...result.data.content];

                if(result.data.content.length > 1){
                    setShowCommunityType(true);
                }else if(result.data.content.length == 1){
                    setDefaultRelation(result.data.content[0]);
                }
                setRelations(otherRelations);
                
            }
        } catch (error) {
            console.log("onLoadRelation error:", error);
        }
        setShowLoading(false);
    }

    

    const onAddPeople = () => {
        setShowForm(true)
        if(!relations || relations.length === 0){
            onLoadRelations();
        }
    }

    const onSubmitNewCommunity = async (params) => {
        params.ownerId = cache.getContact().id;
        params.ownerName = cache.getContact().first_name + (cache.getContact().last_name ? " " + cache.getContact().last_name : "");
        params.isOwner = true;
        let newGroup = params.group;
        let groupExists = groups.find(item => item.group === newGroup && item.isOwner === true);
        if(groupExists)
        {
            setShowProcessing(false);
            showMessage({ status: true, message: t('GROUP_NAME_EXISTS'), callBackFn: () => {
                setShowForm(false);
                setShowNewGroup(false)
                setMessage({})
            }});
        }
        else{
            setCommunitySelected(params);
            setShowForm(true);
            setShowNewGroup(false);
        }
    }
    

    const onSubmitCommunityNameChange = async (newGroupName) => {
        let body = {
            name : newGroupName
        }
        try {
            await crmservices.communitity.updateContactGroups(body, communitySelected.group);
            let newGroup = {
                group: newGroupName,
                isOwner: communitySelected.isOwner,
                ownerId: communitySelected.ownerId,
            }
            onRefresh("members", newGroup);
        } catch (error) {
            console.log("onSubmitCommunityNameChange error:", error);
        }
    }

    const onClickAcceptRejectInvitation = async (isAccept) => {
        setShowProcessing(true);
        let body = {
            action : isAccept ? 'ACCEPT' : 'REJECT'
        }

        var result = await crmservices.communitity.acceptRejectCommunityInvitation(body, communitySelected.ownerId, memberSelected.relationship_id);
        if (result.code === 'OK') {
            showMessage({ status: true, message: isAccept ? t('INVITATION_ACCEPTANCE_SUCCESS') : t('INVITATION_REJECTION_SUCCESS'),  callBackFn: () => {
                onRefresh('members');
                setMessage({})
            }});
        } else {
            showMessage({ status: true, message: isAccept ? t('INVITATION_ACCEPTANCE_FAILED') : t('INVITATION_REJECTION_FAILED')});
        }
    }
        

    const onClickResendInvitation = async (invitation_method, first_name, last_name) => {
        let newContact = false;
        if(!memberSelected.contact || !memberSelected.contact.id){
            newContact = true;
        }
        
        let body = {
            group: communitySelected.group,
            persmissions: [],
            is_admin: false,
        };

        let ownerId = null;
        if (communitySelected && communitySelected.ownerId) {
            ownerId = communitySelected.ownerId;
        }
        if(newContact)
        {
            body.contact = {};
            body.contact.first_name = first_name
            body.contact.last_name = last_name

            if(memberSelected.contact.email)
            {
                body.contact.email_address = memberSelected.contact.email
            }
            else{
                body.contact.phone = memberSelected.contact.phone
            }
        }
        else{
            if (invitation_method === 'PHONE') {
                body.phone = memberSelected.contact.phone
            } else {
                body.email = memberSelected.contact.email
                body.phone = memberSelected.contact.phone
            }
        }
        var result = await crmservices.communitity.addCommunityPeople(body, ownerId);
        if (result.code === 'OK') {
            showMessage({ status: true, message: t('INVITATION_SEND_SUCCESS'),  callBackFn: () => {
                setActive("members");
                setMessage({})
            }});
        } else {
            showMessage({ status: true, message: t('INVITATION_SEND_FAILED')});
        }
        return result;
    }

    const onClickDeleteInvitation = async () => {
        setShowProcessing(true);

        var result = await crmservices.communitity.deleteCommunityRelationship(communitySelected.ownerId, memberSelected.relationship_id);
        if (result.code === 'OK') {
            showMessage({ status: true, message: t('INVITATION_DELETION_SUCCESS'),  callBackFn: () => {
                onRefresh('members');
                setMessage({})
            }});
        } else {
            showMessage({ status: true, message: t('INVITATION_DELETION_FAILED')});
        }
    }

    const onClickDeletePeople = async () => {
        
        let memberName = memberSelected && memberSelected.contact ? memberSelected.contact.first_name + (memberSelected.contact.last_name ? " " + memberSelected.contact.last_name : "") : "";
        setConfirm({
            show: true,
            title: t('warning'),
            message: replaceParamTranslation(t('confirm_delete_peole'), [memberName]),
            onAction: () => onDeletePeople(),
            onClose: () => setConfirm(null)
        });
    }

    const onDeletePeople = async () => {
        setShowProcessing(true);        
        try {
            const result = await crmservices.communitity.deleteCommunityPeople(memberSelected.relationship_id);
            if (result.code === 'OK') {
                setConfirm({});
                onRefresh('members');
            }
        } catch (error) {
            console.log("onDeletePeople error:", error);
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
        }
        setShowProcessing(false);
    }

    const showMessage = ({ status, title, message, otherMessage, callBackFn }) => {
        setShowProcessing(false);
        setMessage({ show: status, title: title, content: message, otherMessage, callBackFn: callBackFn ? callBackFn : () => setMessage({}) });
    }

    const onRefresh = (actveTab, newGroup) => {
        setGroups([]);
        setMembers([]);
        onLoadMyGroups();
        onLoadJoinedCommunities();
        if(actveTab=='members')
        {
            if(newGroup){
                setCommunitySelected(newGroup);
                onLoadMembers(newGroup);
            }
            else{
                setCommunitySelected(communitySelected);
                onLoadMembers(communitySelected);
            }
            setMemberSelected(null);
        }
        if(actveTab=='communities')
        {
            setShowForm(false);
        }
        setActive(actveTab);
    }

    const onSwitchRole = (item) => {
        let _people = people ? people : item;
        if(item) setPeople(item);
        let people_name = _people ? _people.community_owner.first_name + (_people.community_owner.last_name ? " " + _people.community_owner.last_name : "") : "";
        setConfirm({
            show: true,
            title: t('warning'),
            message: replaceParamTranslation(t('confirm_switch_community'), [people_name]),
            onAction: () => onProcessSwitchRole(_people),
            onClose: () => setConfirm(null)
        })
    }

    const onProcessSwitchRole = async (_people) => {
        setConfirm({})
        setShowProcessing(true);
        try {
            const result = await crmservices.communitity.switchRole(_people.community_owner.id, true);
            if (result.code === 'OK') {
                setShowProcessing(false);
                saveDataIntoAsyncStore('current_workspace', 'community_owner');
                if(_people.relation && _people.relation.name){
                saveDataIntoAsyncStore('community_relation', _people.relation.name);
                }
                navigate(config_path.home);
            } else {
                showMessage({ status: true, message: t('SWITCH_ROLE_FAIL') });
            }
        } catch (ex) {
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
        }
        setShowProcessing(false);
    }

    const onLeaveCommunity = () => {
        let people_name = communitySelected.ownerName;
        setCommunitySelected(communitySelected);
        setShowConfirmWithMessage({
            show: true,
            message: replaceParamTranslation(t('confirm_delete_community'), [people_name, communitySelected.group]),
            actionTitle: t('yes'),
            closeTitle: t('no'),
            type: 'leave_community'
        })
    }

    const onProcessLeaveCommunity = async () => {
        setShowConfirmWithMessage({
            show: false,
            message: null,
            type: null
        })
        setShowProcessing(true);
        try {
            const result = await crmservices.communitity.leaveCommunity(communitySelected.ownerId);
            if (result.code === 'OK') {
                setGroups([])
                onRefresh('communities');
            } else {
                showMessage({ status: true, message: t('LEAVE_COMMUNITY_FAIL') });
            }
        } catch (ex) {
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
        }
        setShowProcessing(false);
    }

    const onCancel = () => {
        setCommunitySelected(communitySelected);
        setShowConfirmWithMessage({
            show: false,
            message: null,
            type: null
        })
    }

    const onConfirmAction = async () => {
        let type = showConfirmWithMessage.type;
        if (type === 'leave_community') {
            await onProcessLeaveCommunity();
        } else if (type === 'switch_role') {
            await onProcessSwitchRole();
        }
    }

    const onChange = (target, value, label) => {
        setDefaulValues(prevState => ({
            ...prevState,
            [target]: (label ? { [label]: value } : value)
        }));
    }

    return (
        <>
            {active==='communities' && <CommunitiesPage
                message={message}
                showLoading={showCommunitiesLoading}
                groups={groups}
                onSeeMembers={onSeeMembers}
                active={active}
                fromMenuProfile={fromMenuProfile}
                from={from}
                setActive={setActive}
                onSwitchRole={onSwitchRole}
                onCreateNewGroup={onCreateNewGroup}
                joinedGroups={joinedGroups}
            />}

            {active==='members' && <CommunityMembersView
                members = {members}
                showLoading={showLoading}
                communitySelected={communitySelected}
                setActive={setActive}
                onAddMember={onAddPeople}
                onSubmitCommunityNameChange={onSubmitCommunityNameChange}
                onSeeMember={onSeeMember}
                onSwitchRole={onSwitchRole}  
                joinedGroups={joinedGroups}
            />}

            {active==='member' && <CommunityMemberView
                memberSelected = {memberSelected}
                communitySelected={communitySelected}
                setActive={setActive}
                onClickResendInvitation={onClickResendInvitation}
                onClickDeleteInvitation={onClickDeleteInvitation}
                onClickAcceptRejectInvitation={onClickAcceptRejectInvitation}
                onLeaveCommunity={onLeaveCommunity}
                onClickDeletePeople={onClickDeletePeople}
                allowances={allowances}
                onRefresh={onRefresh}
                showLoading ={showLoading}
            />}

            {showNewGroup && <NewCommunityView
                showLoading={showLoading}
                setShowNewGroup={setShowNewGroup}
                relations={relations}
                // showCommunityType={showCommunityType}
                onChange={onChange}
                onSubmit={onSubmitNewCommunity}
                defaultValues={defaultValues}
                groups={groups}
            />}

            {showProcessing && <LoadingComponent showLoading={showProcessing} />}

            {showForm && <AddMemberPage
                isOpen={showForm}
                communitySelected={communitySelected}
                showCommunityType={showCommunityType}
                relations={relations}
                defaultRelation={defaultRelation}
                onClose={() => setShowForm(false)}
                setShowForm={setShowForm}
                onRefresh={() => onRefresh("communities")}
            />}

            {confirm && confirm.show && <ConfirmComponent
                isOpen={confirm.show}
                message={confirm.message}
                title={confirm.title}
                actionTitle={confirm.actionTitle}
                closeTitle={confirm.closeTitle}
                onClose={confirm.onClose}
                onAction={confirm.onAction}
            />}
            {showConfirmWithMessage && showConfirmWithMessage.show && <ConfirmComponent
                isOpen={showConfirmWithMessage.show}
                message={showConfirmWithMessage.message}
                title={showConfirmWithMessage.title}
                onClose={onCancel}
                onAction={onConfirmAction}
                actionTitle={showConfirmWithMessage.actionTitle}
                closeTitle={showConfirmWithMessage.closeTitle}
            />}
            {message && message.show && <AlertComponent
                isOpen={message.show}
                message={message.content}
                otherMessage={message.otherMessage ? message.otherMessage : null}
                onClose={message.callBackFn}
            />}
           
        </>
    )
}